import { render } from "./PairScan.vue?vue&type=template&id=f0ae9542&scoped=true"
import script from "./PairScan.vue?vue&type=script&lang=ts"
export * from "./PairScan.vue?vue&type=script&lang=ts"

import "./PairScan.vue?vue&type=style&index=0&id=f0ae9542&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f0ae9542"

export default script